module.exports = __webpack_public_path__ + "static/media/NoirPro-Heavy.a302e546.woff";